import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CODES } from "../../consts/codes";
import { GetCatalogues, ListDownloadCatalogue } from "../../services/user/catalogueService";

/** Slice de Redux para el estado de catálogos. */
export const catalogueSlice = createSlice({
  name: "catalogue",
  initialState: {
    catalogueLoad: [],
    catalogueLoadStatus: "fetch",
    catalogueDownload: [],
    catalogueDownloadStatus: "fetch",
    error: null,
  },
  reducers: {
    /** Reinicia el estado de carga del catálogo a "fetch". @param {Object} state - Estado actual del slice @param {Object} action - Acción de Redux */
    resetCatalogueLoadState(state, action) {
      state.catalogueLoadStatus = "fetch";
    },
    /** Reinicia el estado de descarga del catálogo a "fetch". @param {Object} state - Estado actual del slice @param {Object} action - Acción de Redux */
    resetCatalogueDownloadState(state, action) {
      state.catalogueDownloadStatus = "fetch";
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchCatalogueLoad.pending, (state, action) => {
        state.catalogueLoadStatus = "loading";
      })
      .addCase(fetchCatalogueLoad.fulfilled, (state, action) => {
        state.catalogueLoadStatus = "succeeded";
        state.catalogueLoad = action.payload;
      })
      .addCase(fetchCatalogueLoad.rejected, (state, action) => {
        state.catalogueLoadStatus = "failed";
        state.catalogueLoad = [];
      })
      .addCase(fetchCatalogueDownload.pending, (state, action) => {
        state.catalogueDownloadStatus = "loading";
      })
      .addCase(fetchCatalogueDownload.fulfilled, (state, action) => {
        state.catalogueDownloadStatus = "succeeded";
        state.catalogueDownload = action.payload;
      })
      .addCase(fetchCatalogueDownload.rejected, (state, action) => {
        state.catalogueDownloadStatus = "failed";
      });
  },
});

/** Obtiene la lista de catálogos cargados. @param {Object} state - Estado global de Redux @returns {Array} Lista de catálogos */
export const getCatalogueLoad = (state) => state.catalogue.catalogueLoad;
/** Obtiene el estado de la carga de catálogos. @param {Object} state - Estado global de Redux @returns {string} Estado de carga */
export const getCatalogueLoadStatus = (state) => state.catalogue.catalogueLoadStatus;

/** Obtiene la lista de descargas de catálogos. @param {Object} state - Estado global de Redux @returns {Array} Lista de descargas */
export const getCatalogueDownload = (state) => state.catalogue.catalogueDownload;
/** Obtiene el estado de la descarga de catálogos. @param {Object} state - Estado global de Redux @returns {string} Estado de descarga */
export const getCatalogueDownloadStatus = (state) => state.catalogue.catalogueDownloadStatus;

export const { resetCatalogueLoadState, resetCatalogueDownloadState } = catalogueSlice.actions;

/** Obtiene la lista de catálogos desde el servicio. @param {Object} data - Parámetros de consulta @returns {Promise<Array|undefined>} Lista de catálogos o undefined si falla */
export const fetchCatalogueLoad = createAsyncThunk(
  "catalogue/fetchAllCatalogueLoad",
  async (data) => {
    //TODO: Ajustar el objeto GetCatalogues por integracion de grupo empresarial
    const requestCatalogueLoad = await GetCatalogues({
      ...data,
    });

    if (
      requestCatalogueLoad.status === CODES.COD_RESPONSE_SUCCESS &&
      requestCatalogueLoad.data.responseCode === CODES.COD_RESPONSE_SUCCESS
    ) {
      return requestCatalogueLoad.data.data;
    }
  },
);

//TODO: en esta funcion ajuste el objecto para recibir el objecto para que funione como grupo empresarial
/** Obtiene la lista de descargas de catálogos desde el servicio. @param {Object} data - Parámetros de consulta @returns {Promise<Array|undefined>} Lista de descargas o undefined si falla */
export const fetchCatalogueDownload = createAsyncThunk(
  "catalogue/fetchAllCatalogueDownload",
  async (data) => {
    const requestCatalogueDownload = await ListDownloadCatalogue({
      ...data,
    });

    if (requestCatalogueDownload.status === CODES.COD_RESPONSE_SUCCESS) {
      if (requestCatalogueDownload.data.responseCode === CODES.COD_RESPONSE_SUCCESS) {
        return requestCatalogueDownload.data.data;
      }
    }
  },
);

/** Reducer del slice de catálogos. */
export default catalogueSlice.reducer;